import { render, staticRenderFns } from "./SliderDisabled.vue?vue&type=template&id=5c84b3ac"
import script from "./SliderDisabled.vue?vue&type=script&lang=js"
export * from "./SliderDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports